import Content, { Type } from '../types/enums/content';
import ContainerType from '../types/enums/container';
import RegularEvent from './regularEvent';
import { IMediaProductionEventRequest } from '../types/interfaces/event';

class MediaProduction extends RegularEvent {
  contentContainerType: ContainerType;
  isRecord?: boolean;
  seasonCode?: string;
  seasonId: string;
  seasonEpisodes?: number;
  category?: string;

  constructor(request: IMediaProductionEventRequest, isRecord?: boolean) {
    let type = Content.MEDIA_PRODUCTION;
    switch (request.type) {
      case Type.SEASON:
        type = Content.SEASON;
        break;
      case Type.SERIES:
        type = Content.SERIES;
        break;
    }

    super(request, type);
    this.category = request.category;
    this.contentContainerType = request.type;
    this.duration =
      Math.round(request.duration / 60) ||
      (request.length !== undefined ? request.length : 0);
    this.isRecord = isRecord;
    this.seasonCode =
      request.seasonId && this.channel?.name
        ? `S_${request.seasonId}-${this.channel.name}`
        : undefined;
    this.seasonId = request.seasonId || '';
    this.seasonEpisodes = request.seasonEpisodes;
  }
}

export default MediaProduction;
